import React, { Component } from "react";
import PropTypes from "prop-types";

import "./StickyBanner.scss";

export default class StickyBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fixed: false,
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    this.handleScroll();
    window.addEventListener("resize", this.handleScroll);
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleScroll);
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    const section = document.getElementsByClassName("container-sticky")[0];

    if (section.clientHeight > 0) {
      this.setState({
        fixed: window.pageYOffset > 65,
      });
    } else {
      const hasChild = document
        .getElementsByClassName("sticky-element")[0]
        .hasChildNodes();

      if (hasChild) {
        this.setState({
          fixed: window.pageYOffset > 65,
        });
      } else {
        this.setState({
          fixed: false,
        });
      }
    }
  }

  render() {
    return (
      <section
        className={`Sticky-Banner ${this.state.fixed ? "fixed" : ""} ${
          this.props.isExpanded ? "expanded" : " collapsed"
        }`}
      >
        <div>
          <div className="container-sticky">
            {React.Children.map(this.props.children, (child) => child)}
          </div>
        </div>
      </section>
    );
  }
}

StickyBanner.propTypes = {
  isExpanded: PropTypes.bool,
};
